export * from './lib/custom-trans-loader';
